
type loginProps = {
    address: string;
    password: string;
}
/**
 * ログインボタン押下時の入力チェック
 * @param Props
 * @returns 
 */
export function loginValidate(Props: loginProps){
    const message: string[] = [];

    const address = Props.address;
    const password = Props.password;

    //  NULLチェック
    if(address === '' && password === ''){
        message.push('メールアドレスとパスワードを入力してください。');
    }else if(address === ''){
        message.push('メールアドレスを入力してください。');
    }else if(password === ''){
        message.push('パスワードを入力してください。')
    }
    
    return message;
}


/**
 * パスワード再設定メール送信時の入力チェック
 */
export function resetInputValidate(address: string){
    const message: string[] = [];

    const resetAddress = address;
    
    //  入力チェック
    if(resetAddress === ''){
        message.push('メールアドレスを入力してください。')
    }
    else if(!addressCheck(resetAddress)){
        message.push('メールアドレスの形式で入力してください。')
    }

    return message;
}


/**
 * 
 * @param address メールアドレスの形式チェック
 * @returns 
 */
function addressCheck(address:string){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!emailRegex.test(address)){
        return false
    }

    return true
}